"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var React = require("react");
var riskListToolbar_1 = require("./riskListToolbar");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var urls_1 = require("../../urls");
var riskTable_1 = require("./riskTable");
var controlDetail_1 = require("../controls/controlDetail");
var riskbimContext_1 = require("../../context/RiskBim/riskbimContext");
var RiskBimMaps_1 = require("../riskPage/RiskBimMaps");
var RiskList = (function (_super) {
    __extends(RiskList, _super);
    function RiskList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickExportToExcel = function (event) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var url = (0, urls_1.resolve)(urls_1.Urls.risk_excel, context.project) + window.location.search;
                spinnerStart();
                poll_for_result(url, {}, function () {
                    $('div.load_indicator span#finished').html("0");
                    $('div.load_indicator span#max').html("1");
                }, function (data) {
                }, function () {
                    spinnerStop();
                }, function (errorThrown) {
                    notification(errorThrown, { type: "error" });
                    spinnerStop();
                });
            }
            else {
                throw new Error("Cannot export to Excel in this context");
            }
        };
        _this.clickHandler = function (event, url, popup) {
            if (popup) {
                window.open(url + window.location.search);
            }
            else {
                window.location.href = url;
            }
        };
        return _this;
    }
    RiskList.prototype.render = function () {
        var data = App_1.store.risklist.data;
        var has_bim2d = App_1.store.risklist.has_bim2d.get();
        var project_title = App_1.store.risklist.project_title;
        var context = App_1.store.context.get();
        return (React.createElement("div", { className: "RiskList" },
            React.createElement("div", { className: "Div--Background rounded px-3 pb-4 pt-1" },
                React.createElement(riskbimContext_1.RiskBimContextProvider, { project_id: context.project, type: "risk" },
                    React.createElement(riskListToolbar_1.default, { read_only: data.read_only, has_business_model: data.has_business_model, has_bim2d: has_bim2d, project_title: project_title, clickHandler: this.clickHandler, clickExportHandler: this.onClickExportToExcel, rows_counter: data.paginator.items }),
                    React.createElement(riskTable_1.default, null),
                    React.createElement(RiskBimMaps_1.RiskBimDialog, { type: "risk" })),
                React.createElement(controlDetail_1.ControlDetailApp, null))));
    };
    RiskList = __decorate([
        mobx_react_1.observer
    ], RiskList);
    return RiskList;
}(React.Component));
exports.default = RiskList;
